export const PREMIUM_BUTTON_ID = "owaPremiumBtn_container";
export const BUY_MICROSOFT365_BUTTON_ID = "owaBuyMicrosoft365Btn_container";
// Maximum rendered width (in pixels) for the Buy Microsoft 365 header button. The button sizes to
// its content and is capped at this value so it fits the header without a fragile per-locale width
// calculation; longer translations truncate with an ellipsis (see OwaHeaderButtonGroup styling).
export const BUY_MICROSOFT365_MAX_WIDTH = 208;
export const REWARDS_BUTTON_ID = "owaRewardsBtn_container";
export const MY_DAY_BUTTON_ID = "owaTimePanelBtn_container";
export const NOTIFICATIONS_BUTTON_ID = "owaActivityFeedButton_container";
export const SETTINGS_BUTTON_ID = "owaSettingsBtn_container";
export const TEAMS_BUTTON_ID = "owaTeamsBtn_container";
export const SYNC_BUTTON_ID = "owaSyncButton_container";
export const UNDO_BUTTON_ID = "owaUndoButton_container";
export const UPDATE_AVAILABLE_BUTTON_ID = "owaUpdateAvailableButton_container";
// Maximum rendered width for the stale-flight update action label. Longer translations truncate
// with an ellipsis through the shared wide-content header button styling.
export const UPDATE_AVAILABLE_BUTTON_MAX_WIDTH = 160;
